import React, {useState} from 'react';
import './welcome.scss';
import HowToFundPopup from "../HowToFundPopup/HowToFundPopup";
import {productTypes} from "../../../utils/productHelpers";
import {useUnifiedAnalytics} from "../../../contexts/AnalyticsWrapper";
import IsaAllowance from "./IsaAllowance/IsaAllowance";
import withFeatureFlags from '../../../components/FeatureFlags/withFeatureFlags';

/** @import {WelcomeProps} from './WelcomeTypes' */

const Welcome = (/** @type { WelcomeProps & { featureEnabled?: (flag: string) => boolean }} */ { name, data, featureEnabled }) => {

  const analytics = useUnifiedAnalytics();
    
  // Check if customer has at least one ISA account
  const showIsaAllowance = data?.customer?.accounts?.some(account => 
    account && 
    account.product && 
    account.product.productType === productTypes.FixedRateCashISA
  );
  
  const [modalOpen, setModalOpen] = useState(false);
  
  const onModalClose = () => {
    setModalOpen(false);
    const body = document.body;
    body.style.height = '';
    body.style.overflowY = ''; 
    body.style.position = '';
  };

  // Buttons for deposit/open account are rendered in Accounts.jsx

  return (
    <div>
      <div className="dashboard-welcome">
        <div className="dashboard-welcome__content">
          <h1 className="dashboard-welcome__title">Hi {name}</h1>
          {showIsaAllowance ? (
            <div className="dashboard-welcome__row">
              <div className="dashboard-welcome__subtitle">Welcome to your Dashboard</div>
              <div className="dashboard-welcome__aside">
                <IsaAllowance
                  totalAllowance={data?.customer?.isaAllowance?.totalAllowance}
                  usedAmount={data?.customer?.isaAllowance?.usedAllowance}
                  taxYear={data?.customer?.isaAllowance?.taxYear}
                  remainingAllowance={data?.customer?.isaAllowance?.remainingAllowance}
                />
              </div>
            </div>
          ) : (
            <div className="dashboard-welcome__subtitle dashboard-welcome__subtitle--standalone">Welcome to your Dashboard</div>
          )}
        </div>
      </div>
      {modalOpen && <HowToFundPopup data={data} onClose={onModalClose}/>}
    </div>
  );
};

export default withFeatureFlags(Welcome);
